import { Component, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { UserData } from '../../providers/user-data';
import { CommonData } from '../../providers/common-data';
import { ParkbewilligungenData, PbKategorieTyp } from '../../pages/parkbewilligungen/parkbewilligungen-data';
import moment from 'moment';

/**
 * Generated class for the PbcheckresultComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
 
@Component({
  selector: 'pbcheckresult',
  templateUrl: 'pbcheckresult.html'
})
export class PbcheckresultComponent {
  private _checkresultdata;
  public PbKategorieTyp = PbKategorieTyp;
  @Input('checkresultdata') 
  get checkresultdata(): any {
    return this._checkresultdata;
  }
  set checkresultdata(value: any) {
    
    if(!value || value == ""){
      this._checkresultdata = [];
      return;
    }
    let tmp:any;
    if(!Array.isArray(value)){
      tmp = JSON.parse(value);
      //-- Check if new (px5) checkdata -----------
      if(tmp.hasOwnProperty('check')){
        tmp = tmp.check;
      }
    }
    else{
      tmp = value;
    }
    tmp.forEach(element => {
      element.bShowPbDetail = false;
    });
    this._checkresultdata = tmp;
    //console.log(this._checkresultdata);
    //this.refreshCategoryDetails();
  }    

  @Output() onChange: EventEmitter<any> = new EventEmitter<any>();


  constructor(
    public userData: UserData
    , public common: CommonData
  ) 
  {
    this._checkresultdata = [];
  }

  togglePbDetails(pbResult) {
    pbResult.bShowPbDetail = !pbResult.bShowPbDetail;
  }
  
}



// WEBPACK FOOTER //
// ./src/components/pbcheckresult/pbcheckresult.ts